import React from 'react';
import PropTypes from 'prop-types';

import SimpleAvatar from '../common/SimpleAvatar';
import Button from '../Button';
import Card from '../Card';
import styles from './index.styl';

function UserInfoCard({
  onClick,
  disabled,
  avatarUrl,
  avatarText,
  avatarSize,
  buttonText,
  buttonColor,
  textPrimary,
  cardClassName,
  wrapperClassName,
  textComplementary,
}) {
  return (
    <div className={wrapperClassName}>
      <Card
        className={cardClassName}
        text={{
          primary: textPrimary,
          complementary: textComplementary,
        }}
        additionalContent={{
          left: (
            <SimpleAvatar src={avatarUrl} text={avatarText} size={avatarSize} />
          ),
        }}
      />
      <If condition={Boolean(buttonText)}>
        <Button color={buttonColor} onClick={onClick} disabled={disabled}>
          {buttonText}
        </Button>
      </If>
    </div>
  );
}

UserInfoCard.defaultProps = {
  wrapperClassName: styles.cardWrapper,
  cardClassName: styles.card,
};

UserInfoCard.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  avatarUrl: PropTypes.string,
  avatarText: PropTypes.string,
  avatarSize: PropTypes.number,
  buttonText: PropTypes.string,
  buttonColor: PropTypes.string,
  textPrimary: PropTypes.string,
  cardClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  textComplementary: PropTypes.string,
};

export default UserInfoCard;



// WEBPACK FOOTER //
// ./src/components/UserInfoBlock/UserInfoCard.jsx